export const normalizeStatus = status => {
    const statusData = [...status];
    return [...statusData].map(e => {
        return {
            id: e.Id,
            value: e.Description,
        };
    });
};
